export const borderRadius = {
  weak: "0.4rem",
  medium: "1rem",
  strong: "1.6rem",
  round: "50%",
};
